module.exports = __webpack_public_path__ + "static/img/HK.bf68e0d7.png";